(function(){
function connectGallerySwipe(){
 if(document.__presteemGallerySwipe)return()=>{};
 const mobile=matchMedia('(max-width:760px)'),cleanups=[];
 function connect(){
  if(!mobile.matches)return;
  const gallery=document.querySelector('#product .gallery');
  if(!gallery||gallery.querySelector('.gallery-cards'))return;
  const thumbs=[...gallery.querySelectorAll('.gallery-selector button')];
  const lane=document.createElement('div'),track=document.createElement('div');
  lane.className='gallery-cards gallery-direct';lane.tabIndex=0;
  lane.setAttribute('role','region');lane.setAttribute('aria-label','Product photos. Swipe to browse.');
  track.className='gallery-track';lane.append(track);
  thumbs.forEach((thumb,i)=>{
   const card=document.createElement('div'),img=document.createElement('img');
   card.className='gallery-card';card.dataset.index=String(i);
   img.src=thumb.querySelector('img').currentSrc||thumb.querySelector('img').src;
   img.alt=thumb.getAttribute('aria-label');img.draggable=false;img.decoding='async';
   if(img.src.includes('slate'))card.dataset.slate='true';
   card.append(img);track.append(card);
  });
  gallery.insertBefore(lane,gallery.querySelector('.gallery-main'));gallery.classList.add('gallery-cards-ready');
  let index=Math.max(0,thumbs.findIndex(t=>t.getAttribute('aria-pressed')==='true'));
  let gesture=null,frame=0,finishTimer=0,syncing=false,lastWidth=0,offset=0,pendingOffset=null;
  const step=()=>lane.clientWidth+16;
  const limit=i=>Math.max(0,Math.min(thumbs.length-1,i));
  function sync(){
   lane.dataset.active=String(index);
   if(thumbs[index].getAttribute('aria-pressed')!=='true'){
    syncing=true;thumbs[index].click();syncing=false;
   }
  }
  function draw(x){offset=x;track.style.transform=`translate3d(${x}px,0,0)`;}
  function settle(next,animate=true){
   cancelAnimationFrame(frame);frame=0;clearTimeout(finishTimer);
   if(pendingOffset!==null){draw(pendingOffset);pendingOffset=null;}
   const target=limit(next);
   const remaining=Math.abs(-target*step()-offset);
   const duration=target===index?260:Math.round(340+120*Math.min(1,remaining/step()));
   index=limit(next);
   // Commit the last finger position before starting the release animation.
   getComputedStyle(track).transform;
   track.style.transition=animate&&!matchMedia('(prefers-reduced-motion:reduce)').matches?`transform ${duration}ms cubic-bezier(.25,.45,.35,1)`:'none';
   draw(-index*step());lane.dataset.active=String(index);
   // Update React only after movement, never while the finger is dragging.
   if(animate)finishTimer=setTimeout(sync,duration+20);else sync();
  }
  thumbs.forEach((thumb,i)=>{
   const click=()=>{if(!syncing){gesture=null;settle(i,false);}};
   thumb.addEventListener('click',click);cleanups.push(()=>thumb.removeEventListener('click',click));
  });
  function start(e){
   clearTimeout(finishTimer);cancelAnimationFrame(frame);frame=0;pendingOffset=null;
   const matrix=new DOMMatrixReadOnly(getComputedStyle(track).transform);
   track.style.transition='none';draw(matrix.m41);
   gesture={id:e.pointerId,x:e.clientX,y:e.clientY,start:offset,index,axis:null,lastX:e.clientX,lastTime:e.timeStamp,velocity:0};
  }
  function move(e){
   const g=gesture;if(!g||g.id!==e.pointerId)return;
   const dx=e.clientX-g.x,dy=e.clientY-g.y;
   if(!g.axis&&Math.max(Math.abs(dx),Math.abs(dy))>5)g.axis=Math.abs(dx)>Math.abs(dy)?'x':'y';
   if(g.axis!=='x')return;
   if(e.cancelable)e.preventDefault();
   const dt=e.timeStamp-g.lastTime;if(dt>0)g.velocity=(e.clientX-g.lastX)/dt;
   g.lastX=e.clientX;g.lastTime=e.timeStamp;
   let x=g.start+dx;const min=-(thumbs.length-1)*step();
   if(x>0)x=Math.min(48,x*.22);else if(x<min)x=min-Math.min(48,(min-x)*.22);
   pendingOffset=x;
   if(!frame)frame=requestAnimationFrame(()=>{frame=0;if(pendingOffset!==null){draw(pendingOffset);pendingOffset=null;}});
  }
  function end(e,cancelled=false){
   const g=gesture;if(!g||g.id!==e.pointerId)return;
   gesture=null;if(typeof e.pointerId==='number'&&lane.hasPointerCapture(e.pointerId))lane.releasePointerCapture(e.pointerId);
   const dx=e.clientX-g.x;
   const flick=e.timeStamp-g.lastTime<100&&Math.abs(g.velocity)>.35&&Math.abs(dx)>12;
   const next=!cancelled&&g.axis==='x'&&(Math.abs(dx)>=32||flick)?g.index-Math.sign(dx):g.index;
   settle(next,true);
  }
  // iPhone uses Touch Events directly. Do not let pointercancel interrupt a touch drag.
  const touchEvent=(event,touch)=>({pointerId:'touch',clientX:touch.clientX,clientY:touch.clientY,timeStamp:event.timeStamp,cancelable:event.cancelable,preventDefault:()=>event.preventDefault()});
  lane.addEventListener('touchstart',event=>{
   if(event.touches.length!==1){gesture=null;settle(index,true);return;}
   start(touchEvent(event,event.touches[0]));
  },{passive:true});
  lane.addEventListener('touchmove',event=>{
   if(event.touches.length===1)move(touchEvent(event,event.touches[0]));
  },{passive:false});
  lane.addEventListener('touchend',event=>{
   if(event.changedTouches.length)end(touchEvent(event,event.changedTouches[0]));
  },{passive:true});
  lane.addEventListener('touchcancel',event=>{
   if(event.changedTouches.length)end(touchEvent(event,event.changedTouches[0]),true);
   else {gesture=null;settle(index,true);}
  },{passive:true});
  lane.addEventListener('pointerdown',e=>{
   if(e.pointerType!=='mouse'||e.button!==0)return;
   start(e);lane.setPointerCapture(e.pointerId);
  });
  lane.addEventListener('pointermove',e=>{if(e.pointerType==='mouse')move(e);});
  lane.addEventListener('pointerup',e=>{if(e.pointerType==='mouse')end(e);});
  lane.addEventListener('pointercancel',e=>{if(e.pointerType==='mouse')end(e,true);});
  lane.addEventListener('lostpointercapture',e=>{if(gesture&&gesture.id===e.pointerId){gesture=null;settle(index,true);}});
  lane.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();});
  lane.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();settle(index+(e.key==='ArrowRight'?1:-1));}});
  const resize=new ResizeObserver(()=>{if(lane.clientWidth!==lastWidth){lastWidth=lane.clientWidth;gesture=null;settle(index,false);}});resize.observe(lane);
  const decode=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){track.querySelectorAll('img').forEach(img=>img.decode().catch(()=>{}));decode.disconnect();}},{rootMargin:'500px'});decode.observe(lane);
  cleanups.push(()=>{resize.disconnect();decode.disconnect();clearTimeout(finishTimer);cancelAnimationFrame(frame);lane.remove();gallery.classList.remove('gallery-cards-ready');});
  settle(index,false);
 }
 const observer=new MutationObserver(connect);observer.observe(document.body,{childList:true,subtree:true});mobile.addEventListener('change',connect);
 const cleanup=()=>{observer.disconnect();mobile.removeEventListener('change',connect);cleanups.forEach(fn=>fn());delete document.__presteemGallerySwipe;};
 document.__presteemGallerySwipe=cleanup;connect();return cleanup;
}
connectGallerySwipe();
})();
